document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!input.matches('input[type="radio"][data-variant-id]')) return;

    const variantId = input.dataset.variantId;
    const card = input.closest('.product-card, [class*="product-card"]');
    if (!card) return;

    const priceEl = card.querySelector('span.price');
    if (!priceEl) return;

    // Obtener el handle del producto desde el link de la tarjeta
    const productLink = card.querySelector('a[href*="/products/"]');
    if (!productLink) return;

    const match = productLink.href.match(/\/products\/([^?#]+)/);
    if (!match) return;
    const handle = match[1];

    fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .then(product => {
        const variant = product.variants.find(v => v.id == variantId);
        if (!variant) return;

        const price = (variant.price / 100).toLocaleString('es-ES', {
          style: 'currency',
          currency: product.currency || 'EUR'
        });

        priceEl.textContent = price;
      });
  });
});
